import React from "react";
import { Card, Typography, Tag, Empty } from "antd";
import { CommentOutlined } from "@ant-design/icons";

const { Title, Text, Paragraph } = Typography;

export const CommentModerationPage: React.FC = () => {
  return (
    <div>
      <Title level={2}>Modération des commentaires</Title>
      <Text type="secondary" style={{ marginBottom: 24, display: "block" }}>
        Modérez et gérez les commentaires des utilisateurs
      </Text>

      <Card style={{ textAlign: "center", padding: "60px 0" }}>
        <Empty
          image={
            <CommentOutlined style={{ fontSize: 64, color: "#d9d9d9" }} />
          }
          imageStyle={{ height: 80 }}
          description={
            <div>
              <Title level={4} style={{ marginBottom: 8 }}>
                Fonctionnalité à venir
              </Title>
              <Paragraph type="secondary" style={{ maxWidth: 400, margin: "0 auto" }}>
                Le système de modération des commentaires est en cours de développement.
                Il vous permettra de modérer, approuver et supprimer les commentaires
                laissés par les utilisateurs sur les contenus.
              </Paragraph>
              <Tag color="processing" style={{ marginTop: 16 }}>
                En développement
              </Tag>
            </div>
          }
        />
      </Card>
    </div>
  );
};

export default CommentModerationPage;
